/**
 * Created by DELL on 2016/12/16.
 */
export default {
  indexOfTab (arr, val) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === val) return i
    }
    return -1
  },
  removeTab (arr, val) {
    let index = this.indexOfTab(arr, val)
    if (index > -1) {
      arr.splice(index, 1)
    }
  },
  addTab (arr, val) {
    let index = this.indexOfTab(arr, val)
    if (index === -1) {
      arr.push(val)
    }
  },
  // 对象数组中的某一项，当对象的属性field等于val时返回,field是字符串
  getTab (arr, val, field, type) {
    if (arr instanceof Array) {
      let len = arr.length
      for (let i = 0; i < len; i++) {
        if (arr[i][field] === val) {
          return type === 'obj' ? arr[i] : i // 如果设置type为'obj'，则返回对象，否则返回index
        }
      }
      return -1
    } else {
      console.log('arr should be array')
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/tabArr.js